import {
    useDeleteCvV2ApplyMutation,
    useLazyGetApplyV2SocketQuery,
    usePostCvV2ApplyMutation,
} from '@core/app/api/applyJobV2Api'
import type { ApplyV2TempBase64File, ApplyV2TempProfileCvData } from '@core/app/types/applyV2Type'
import { InfoIcon } from '@core/assets/icons/info_icon'
import ApplyV2AttachmentsUploader from '@core/components/ApplyDialogV2/ApplyV2AttachmentsUploader'
import ApplyV2AttachmentsUploader2 from '@core/components/ApplyDialogV2/ApplyV2AttachmentsUploader/ApplyV2AttachmentsUploader2'
import ApplyV2Button from '@core/components/ApplyDialogV2/ApplyV2Button'
import ApplyV2InputRadio from '@core/components/ApplyDialogV2/ApplyV2InputRadio'
import UploadCvIcon from '@core/components/ApplyDialogV2/assets/UploadCvIcon'
import DefaultMaskIcon from '@core/components/ApplyDialogV2/FileUploaderV2/DefaultMaskIcon'
import UnsupportedFileMaskIcon from '@core/components/ApplyDialogV2/FileUploaderV2/UnsupportedFileMaskIcon'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import getAcceptFilesString from '@core/utils/helpers/getAcceptFilesString'
import useApplyV2NavTranslations from '@core/utils/hooks/useApplyV2NavTranslations'
import React, { useEffect, useRef, useState } from 'react'
import './ApplyV2CvStep2.scss'

const getCvParserRadioKey = (postId: number) => `cv_parser_radio_${postId}`
const getCvParserRadioFromStorage = (postId: number): boolean => {
    try {
        const stored = localStorage.getItem(getCvParserRadioKey(postId))
        return stored !== null ? JSON.parse(stored) : true
    } catch {
        return true
    }
}
const setCvParserRadioToStorage = (postId: number, value: boolean) => {
    try {
        localStorage.setItem(getCvParserRadioKey(postId), JSON.stringify(value))
    } catch {
        console.log('Silently fail if localStorage is not available')
    }
}

const baseClass = 'ApplyV2CvStep2'

function ApplyV2CvStep2() {
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
        isFinalStep,
        setIsFinalStep,
        isPostApplied,
        onCloseApply,
        settingsData,
        navItems,
        onNextStep,
        postProfileRefetch,
        sendWebSocketMessage,
        cvParserStatus,
        isWebSocketConnected,
        postData,
    } = useApplyV2Context()
    const { getTitle } = useApplyV2NavTranslations()
    const [files, setFiles] = useState<(ApplyV2TempBase64File | ApplyV2TempProfileCvData)[]>([])

    const postId = postData?.ad?.AdID ?? 0

    const [radio, setRadio] = useState<boolean>(() => {
        return postId > 0 ? getCvParserRadioFromStorage(postId) : true
    })
    const [postCvRequest, { isLoading: isCvLoading, error: cvError }] = usePostCvV2ApplyMutation()
    const [deleteCvRequest, { isLoading: isCvDeleteLoading, isError: isDeleteError }] = useDeleteCvV2ApplyMutation()
    // const [trigger, { data, isFetching, isLoading, isError }] = useLazyGetApplyV2SocketQuery()
    const wsRef = useRef<WebSocket | null>(null)
    const [progress, setProgress] = useState(0)
    const [cvStateError, setCvStateError] = useState<string | null>(null)
    const [isShowInput, setIsShowInput] = useState(true)

    useEffect(() => {
        setIsShowInput(!(files.length || isCvLoading || isCvDeleteLoading))
    }, [files.length, isCvLoading, isCvDeleteLoading])

    // const existingCv = postProfileData?.data?.cv || null

    const isCvRequired = settingsData?.steps?.cv?.required && settingsData?.steps?.cv?.visible

    // const isShowInput = !(files.length || isCvLoading || isCvDeleteLoading)

    // console.log(!files.length, !isCvLoading, !isCvDeleteLoading, isShowInput)

    useEffect(() => {
        let timeout: NodeJS.Timeout | null = null

        const tick = (delay: number) => {
            timeout = setTimeout(() => {
                setProgress((prev) => {
                    if (prev >= 98) return prev

                    let step = 1
                    if (prev >= 90) step = 1

                    const next = prev + step
                    const nextDelay = next < 60 ? delay : delay * 2

                    tick(nextDelay)
                    return next
                })
            }, delay)
        }

        if (isCvLoading) {
            setProgress(0)
            tick(50)
        } else {
            setProgress(0)
        }

        return () => {
            if (timeout) clearTimeout(timeout)
        }
    }, [isCvLoading])

    const handleNext = async () => {
        if (radio) {
            sendWebSocketMessage('subscribe')
            sendWebSocketMessage('cv-parser')
        }
        onNextStep()
    }

    const deleteCvHandler = async () => {
        setCvStateError(null)
        try {
            const res = await deleteCvRequest({
                uid: postProfileData?.data?.uid ?? '',
            }).unwrap()
            setFiles([])
            console.log('Delete res', res)
        } catch (e) { }
    }

    console.log('cvStateError', cvStateError)
    const uploadCvHandler = async (cvs: ApplyV2TempBase64File[]) => {
        setCvStateError(null)
        if (cvs.length > 1) {
            setCvStateError('max 1 file')
            return
        }
        const cv = cvs[0]
        const uid = postProfileData?.data?.uid

        if (!cv || !uid || !('base64' in cv)) {
            console.log('No Cv or Uid')
            return
        }
        try {
            setFiles(cvs)
            const res = await postCvRequest({
                uid: uid,
                body: {
                    cv: {
                        name: cv.name,
                        ext: cv.ext,
                        base64: cv.base64,
                    },
                },
            }).unwrap()
            // .then((res) => {
            //     console.log('CV res ', res)
            // })
            // .catch((e) => {
            //     console.log('Error uploading file', e)
            // })
            // console.log('FFF', res)
        } catch (e: any) {
            setCvStateError(e.message)
            console.log('ERROR', e)
        } finally {
        }
    }

    console.log('Is isWebSocketConnected', isWebSocketConnected, cvParserStatus)

    useEffect(() => {
        if (postId > 0) {
            const storedValue = getCvParserRadioFromStorage(postId)
            setRadio(storedValue)
        }
    }, [postId])

    useEffect(() => {
        if (postProfileData?.data?.cv) {
            setFiles([postProfileData.data.cv])
        } else {
            setFiles([])
        }
    }, [postProfileData?.data?.cv])

    const filesErrors = files
        .map((f) => {
            return { ...f, error: 'errFF' }
        })
        .filter((f) => cvStateError)

    return (
        <div className={baseClass}>
            <ApplyV2AttachmentsUploader2
                maxFileSize={10}
                accept={getAcceptFilesString('CV')}
                files={files}
                onChange={uploadCvHandler}
                multipleCount={1}
                progressItems={isCvLoading ? [{ index: 0, progress }] : []}
                onDelete={deleteCvHandler}
                errorMessage={cvStateError}
                isShowInput={isShowInput}
                // filesErrors={filesErrors}
                loadingIds={
                    isCvDeleteLoading
                        ? files.map((f) => {
                            if ('uid' in f) {
                                return f.uid
                            } else {
                                return f.name
                            }
                        })
                        : []
                }
            >
                <UploadCvIcon className={`${baseClass}__icon`} />
                <p
                    className={`${baseClass}__inner__text`}
                    style={{
                        fontSize: '12px',
                        marginBottom: '2px',
                        marginTop: '8px',
                        fontWeight: 500,
                    }}
                >
                    {getTitle('10348', 'Drop files here or click to upload')}
                </p>
                <p
                    style={{
                        fontSize: '11px',
                        color: '#999',
                    }}
                >
                    PDF / DOC / DOCX
                </p>
            </ApplyV2AttachmentsUploader2>

            {(!files.length || isCvLoading) && (
                <div className={`${baseClass}__info`}>
                    <span className={`${baseClass}__info-icon`}>
                        <InfoIcon />
                    </span>
                    <span>
                        {/* {getTitle(
                            '10425',
                            'Information from your CV file can be automatically parsed to fill in the details in the following steps.'
                        )} */}
                        {getTitle(
                            '10696',
                            'Information from your CV will be automatically used to fill in your profile and the next steps. You can add, or edit details anytime.'
                        )}
                    </span>
                </div>
            )}
            {!!files.length && !isCvLoading && (
                <div className={`${baseClass}__description`}>
                    <p className={`${baseClass}__description--title`}>
                        {getTitle('8799', 'Would you like to automatically parse your CV?')}
                    </p>
                    <p className={`${baseClass}__description--par`}>
                        {getTitle(
                            '10696',
                            'Information from your CV will be automatically used to fill in your profile and the next steps. You can add, or edit details anytime.'
                        )}
                    </p>
                    {/* <p className={`${baseClass}__description--par`}>
                        {getTitle('10427', 'You will be able to add or edit any information at any time.')}
                    </p> */}
                    <ApplyV2InputRadio
                        className={`${baseClass}__description--radio`}
                        value={radio}
                        onChange={(f) => {
                            const newValue = !!f
                            setRadio(newValue)
                            if (postId > 0) {
                                setCvParserRadioToStorage(postId, newValue)
                            }
                        }}
                        options={[
                            { value: true, label: getTitle('128', 'Yes') },
                            { value: false, label: getTitle('8801', "No, I'll add information myself") },
                        ]}
                    />
                </div>
            )}
            <div className={`ApplyDialogV2__next ${baseClass}__next`}>
                {!settingsData?.steps?.cv?.required && (
                    <ApplyV2Button
                        variant="transparent"
                        className="ApplyDialogV2__next--btn ApplyDialogV2__next--btn-skip"
                        rightIcon={
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M5.25728 13.4386C5.01503 13.2125 5.00193 12.8328 5.22803 12.5906L9.5126 7.99997L5.22804 3.40936C5.00193 3.16711 5.01503 2.78744 5.25728 2.56134C5.49953 2.33524 5.8792 2.34833 6.1053 2.59058L10.772 7.59058C10.9871 7.82111 10.9871 8.17884 10.772 8.40936L6.1053 13.4094C5.8792 13.6516 5.49953 13.6647 5.25728 13.4386Z"
                                    fill="#19191A"
                                />
                            </svg>
                        }
                        onClick={() => onNextStep()}
                    >
                        {getTitle('6107', 'Skip')}
                    </ApplyV2Button>
                )}
                <ApplyV2Button
                    type="submit"
                    variant={'primary'}
                    className={`ApplyDialogV2__next--btn ApplyDialogV2__next--btn-submit`}
                    isLoading={
                        isCvLoading ||
                        cvParserStatus === 'file-search-started' ||
                        cvParserStatus === 'file-sent-to-parsing' ||
                        cvParserStatus === 'in-progress'
                    }
                    isDisabled={isCvLoading || isCvLoading || (isCvRequired && files.length < 1)}
                    onClick={handleNext}
                >
                    {getTitle('3035', 'Next')}
                </ApplyV2Button>
            </div>
        </div>
    )
}

export default ApplyV2CvStep2
